import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withFormik } from 'formik';
import { graphql, compose, withApollo } from 'react-apollo';

import * as messageActions from '../../actions/message-actions';
import { CurrentUser } from '../../queries/CurrentUser';
import { formikConfig } from './formikConfig';
import Form from './Form';
import RedirectWithFilters from '../RedirectWithFilters';

const Settings = ({ location, status, ...restProps }) => {
  if (status && status.redirect) {
    const to = location.state ? location.state.previousPath : '';
    return <RedirectWithFilters to={to} />;
  }
  return <Form {...restProps} />;
};

const SettingsWithData = compose(
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators(messageActions, dispatch)
    })
  ),
  graphql(CurrentUser, {
    options: () => ({ fetchPolicy: 'cache-first' }),
    props: ({ data: { viewer, loading } }) => ({
      loading,
      currentUser: viewer
    })
  }),
  withApollo,
  withFormik(formikConfig)
)(Settings);

export default SettingsWithData;



// WEBPACK FOOTER //
// ./src/component/Settings/index.js